import { FC } from 'react';
import { Drawer } from '@silverfort/sf-components';
import { useAppDrawer } from './AppDrawerProvider';

const AppDrawer: FC = () => {
    const { appDrawerProps, setAppDrawerProps } = useAppDrawer();
    return (
        <Drawer
            onClose={() => setAppDrawerProps({ open: false })}
            darkBackground
            contentClassName="p-[0px] no-scrollbar"
            className="z-[10003]"
            {...appDrawerProps}
        />
    );
};

export default AppDrawer;
